import { useEffect, useState } from "react";

export function useDebounced<T>(newValue: T, delay = 300) {
  const [value, setValue] = useState(newValue);

  useEffect(() => {
    const id = setTimeout(() => setValue(newValue), delay);
    return () => clearTimeout(id);
  }, [newValue, delay]);

  return value;
}
